/** @jsx jsx */

import { Fragment } from 'react';

import { ColorName, Icon, IconName, Spacer, Text } from '@zapier/design-system';
import { jsx, css } from '@emotion/core';

const Styles = {
  root: css`
    display: flex;
    align-items: center;
  `,
};

type Props = {
  /** The color of the text and icon */
  color?: ColorName;
  /** The number to display */
  count: number | string;
  /** The name of the icon to show */
  icon: IconName;
  /** Additional name/text to describe the count number */
  infoName?: string;
  /** Icon size.  */
  size?: number;
};

/**
 * A small infographic showing a number count. Optionally, can add text after the count number.
 */
const InfoCount = ({ color, count, icon, infoName, size = 20 }: Props) => (
  <div css={Styles.root}>
    <Icon color={color} name={icon} size={size} />
    <Spacer width={10} />
    <Text color={color}>{count}</Text>
    {infoName && (
      <Fragment>
        <Spacer width={5} />
        <Text color={color}>{infoName}</Text>
      </Fragment>
    )}
  </div>
);

export default InfoCount;
